module.exports = __webpack_public_path__ + "9027a4706003af4e93f4b894376507f8.png";


//////////////////
// WEBPACK FOOTER
// ./components/review-modal/src/assets/avatar.png
// module id = 2407
// module chunks = 0